<template>
    <sa-page-layout titolo="AnDIamo - Utente" class="sa-no-space" btnRouterBackVisible>
        <template slot="table-body">
            <AndiamoUtenteFormComponent ref="cmpAndiamoUtenteFormComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AndiamoUtenteFormComponent from "../components/AndiamoUtenteFormComponent.vue";

export default {
    components: { SaPageLayout, AndiamoUtenteFormComponent },
};
</script>

<style lang="scss" scoped></style>
